module.exports = __webpack_public_path__ + "static/img/4814_phase_function_Paper_PointsHejduk_Prediction.c71870c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4814_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ma7/
// module chunks = 0